<div class="loading-container" *ngIf="isLoading">
    <mat-spinner diameter="40"></mat-spinner>
</div>

<app-section *ngIf="socioEmotionalSkillsTestResults.length > 0 && !isLoading">

    <app-socio-emotional-skills-test-results-header></app-socio-emotional-skills-test-results-header>

    <div class="bento-dashboard">

        <div class="bento-dashboard__item bento-dashboard__item--full">
            <h2 class="bento-dashboard__title">Tus resultados generales</h2>
            <app-socio-emotional-skills-test-results-general [generalSocioEmotionalSkill]="generalSocioEmotionalSkill"
                [lastThreeResults]="socioEmotionalSkillsTestResults">
            </app-socio-emotional-skills-test-results-general>
        </div>

        <div class="bento-dashboard__item bento-dashboard__item--full">
            <h2 class="bento-dashboard__title">Perfil General de Habilidades</h2>
            <app-socio-emotional-skills-test-results-radar [skills]="socioEmotionalSkills"
                [skillScores]="lastSocioEmotionalSkillsTestResult.skillScores">
            </app-socio-emotional-skills-test-results-radar>
        </div>

        <div class="bento-dashboard__item">
            <h2 class="bento-dashboard__title">Progreso por Habilidad</h2>
            <app-socio-emotional-skills-test-results-progress-table [skills]="socioEmotionalSkills"
                [skillScores]="lastSocioEmotionalSkillsTestResult.skillScores">
            </app-socio-emotional-skills-test-results-progress-table>
        </div>

        <div class="bento-dashboard__item">
            <h2 class="bento-dashboard__title">Tus habilidades más destacadas</h2>
            <app-socio-emotional-skills-test-results-strengths [skills]="socioEmotionalSkills"
                [skillScores]="lastSocioEmotionalSkillsTestResult.skillScores">
            </app-socio-emotional-skills-test-results-strengths>
        </div>

        <div class="bento-dashboard__item bento-dashboard__item--full">
            <h2 class="bento-dashboard__title">Tu progreso</h2>
            <app-socio-emotional-skills-test-results-history-chart [skills]="socioEmotionalSkills"
                [lastThreeResults]="socioEmotionalSkillsTestResults">
            </app-socio-emotional-skills-test-results-history-chart>
        </div>

        <div class="bento-dashboard__item bento-dashboard__item--full">
            <h2 class="bento-dashboard__title">Ideas para Mejorar</h2>
            <p>Pequeñas acciones para seguir creciendo desde casa o el cole.</p>
            <app-socio-emotional-skills-test-results-suggestions [skills]="socioEmotionalSkills"
                [skillScores]="lastSocioEmotionalSkillsTestResult.skillScores">
            </app-socio-emotional-skills-test-results-suggestions>
        </div>
    </div>
</app-section>


<app-section *ngIf="socioEmotionalSkillsTestResults.length == 0 && !isLoading">

    <div class="no-results">
        <h2 class="no-results__title">No se encontraron resultados</h2>
        <img class="no-results__image" src="assets/pre-test/test-bw.png" alt="No data found" />
        <p class="no-results__message">Parece que no has realizado la prueba de habilidades socioemocionales.</p>
        <p class="no-results__message">¡Realiza la prueba para ver tus resultados!</p>

        <app-button [routerLink]="['/socio-emotional-skills-test']">
            Realizar la prueba
        </app-button>

    </div>

</app-section>